export default __webpack_public_path__ + "static/media/chapmanleonard.10eba818.png";